import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "../Context/ShopContext";
const databaseUrl = process.env.REACT_APP_DATABASE_URL;

const OrderSummary = () => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const { cartItems, selectedItems } = useContext(ShopContext);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [total, setTotal] = useState(0);
  const [num_purchase_products, setNumPurchaseProducts] = useState(0);

  useEffect(() => {
    const fetchProducts = async () => {
      const fetchedProducts = {};
      for (const item of selectedItems) {
        try {
          const response = await fetch(
            `${databaseUrl}/product/${item.product_id}`
          );
          const data = await response.json();
          if (data.success) {
            fetchedProducts[item.product_id] = data.product;
          } else {
            console.error(
              `Failed to fetch product ${item.product_id}:`,
              data.message
            );
          }
        } catch (error) {
          console.error(`Error fetching product ${item.product_id}:`, error);
        }
      }
      setSelectedProducts(fetchedProducts); // Store fetched products in state
    };

    if (selectedItems.length > 0) {
      fetchProducts();
    }
  }, [selectedItems]);

  // Update form data when selected products or cart items change
  useEffect(() => {
    if (Object.keys(selectedProducts).length > 0) {
      const productArray = Object.values(selectedProducts); // Convert object to array
      const product_ids = productArray.map((product) => product.id);
      const productnames = productArray.map((product) => product.name);

      // Calculate total and number of purchased products
      let total = 0;
      let num_purchase_products = 0;

      selectedItems.forEach((item) => {
        const quantity = item.quantity || 0;
        const itemInfo = productArray.find(
          (product) => product.id === item.product_id
        );
        if (itemInfo) {
          total += itemInfo.new_price * item.quantity;
        }
        num_purchase_products += quantity;
      });
      setTotal(total);
      setNumPurchaseProducts(num_purchase_products);
    }
  }, [selectedProducts, cartItems]);
  return (
    <div>
      <h2 className="text-xl font-semibold text-[#551e19] mb-4">
        Order Summary
      </h2>
      <div className="space-y-4">
        {selectedItems.map((itemId) => {
          const item = selectedProducts[itemId.product_id]; // Fetch product from selectedProducts
          const quantity = itemId?.quantity || 0;

          if (!item) return null; // Handle cases where the product isn't loaded yet

          return (
            <div
              key={itemId.product_id}
              className="flex items-center space-x-4 p-2 rounded-md shadow-sm overflow-hidden"
            >
              <img
                src={item.image[0]}
                alt="product-image"
                className="w-16 h-16 object-cover rounded-md flex-shrink-0"
              />
              <div className="flex flex-col flex-grow">
                <p className="font-semibold truncate max-w-[200px] text-sm md:text-base">
                  {item.name}
                </p>
                <p className=" text-sm md:text-base">Qty: {quantity}</p>
                <p className=" text-sm md:text-base">Price: Rs. {(item.new_price * quantity).toFixed(2)}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-6 flex justify-between items-center font-normal text-white bg-[#551e19] text-lg px-4 py-2 rounded-md">
        <p>Total</p>
        <p>Rs.{total}</p>
      </div>
    </div>
  );
};

export default OrderSummary;
